import './Page404.css';
import {Helmet} from "react-helmet-async";

export default function Page404() {
    const pageTitle = "404 — Strona nie została znaleziona | Lumestore";
    const description = "Strona, której szukasz, nie istnieje lub została przeniesiona. Wróć na stronę główną Lumestore.";

    return (
        <div id='page-404'>
            {/* SEO */}
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={description} />
                <meta name="robots" content="noindex, follow" />
                <link rel="canonical" href="https://lumestore.pl/404" />

                {/* OG */}
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://lumestore.pl/404" />
                <meta property="og:title" content={pageTitle} />
                <meta property="og:description" content={description} />
            </Helmet>

            <div id='page-404-image-container'>
                {/* tu możesz wrzucić grafikę np. 404.webp */}
            </div>
        </div>
    );
}
